<template>
    <b-row>
        <b-col lg="12">
            <!-- .name -->
            <validation-observer ref="registerForm" #default="{ invalid }">
                <b-form>
                    <b-row>
                                <!-- .user -->
<b-col lg="6">
    <b-form-group id="input-group-1" :label="$t('increments.user')" label-for="input-1">
        <validation-provider #default="{ errors }" name="user" vid="user" rules="required">
            <b-form-select v-model="user"
                           :options="users"
                           text-field="name"
                           value-field="id"
                           :state="errors.length > 0 ? false : null"
                           :placeholder="$t('increments.user')" />
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>        <!-- .month -->
<b-col lg="6">
    <b-form-group id="input-group-2" :label="$t('increments.month')" label-for="input-2">
        <validation-provider #default="{ errors }" name="month" vid="month" rules="required">

            <b-form-input id="input-2" v-model="newItem.month" type="text" :placeholder="$t('increments.month')" :state="errors.length > 0 ? false : null">
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>        <!-- .amount -->
<b-col lg="6">
    <b-form-group id="input-group-3" :label="$t('increments.amount')" label-for="input-3">
        <validation-provider #default="{ errors }" name="amount" vid="amount" rules="required">

            <b-form-input id="input-3" v-model="newItem.amount" type="text" :placeholder="$t('increments.amount')" :state="errors.length > 0 ? false : null">
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>        <!-- .created_by -->
<b-col lg="6">
    <b-form-group id="input-group-4" :label="$t('increments.created_by')" label-for="input-4">
        <validation-provider #default="{ errors }" name="created_by" vid="created_by" rules="required">

            <b-form-input id="input-4" v-model="newItem.created_by" type="text" :placeholder="$t('increments.created_by')" :state="errors.length > 0 ? false : null">
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>        <!-- .purpose -->
<b-col lg="6">
    <b-form-group id="input-group-5" :label="$t('increments.purpose')" label-for="input-5">
        <validation-provider #default="{ errors }" name="purpose" vid="purpose" rules="required">

            <b-form-input id="input-5" v-model="newItem.purpose" type="text" :placeholder="$t('increments.purpose')" :state="errors.length > 0 ? false : null">
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</b-col>
                    </b-row>
                    <hr />
                    <b-row>
                        <b-col lg="6">
                            <b-button block
                                     
                                      :disabled="invalid"
                                      variant="primary"
                                      @click="submit()">
                                <i class="fa fa-plus" /> {{ $t("site.save") }}
                            </b-button>
                        </b-col>
                        <b-col lg="6">
                            <b-button block  @click="goToTable()"  variant="success">
                                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </b-col>
    </b-row>
</template>

<script>
    import Controller from '@/Controllers/IncrementsController';
    import config from '@/config/config';
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import { required } from "@validations";
     export default {
        name: "IncrementsForm",
        props: ['newItem'],
        components: {
            ValidationProvider,
            ValidationObserver,
            required,
        },
        data() {
            return {
                file: {},
                
                        user:[],


            };
        },
        methods: {
            async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
                let ret = await new Controller().From(this.newItem, "FormData");
                if (ret) {
                    this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
                    this.$parent.$parent.firstTab();
                }
            },
        },

};
</script>

